import { DataTable } from "@marketplace/ui/data-table";

import type { ClaimOrderListItem } from "../../dtos/get-claim-order-list-response-dto";
import { useClaimOrderListTableColumns } from "../../hooks/use-claim-order-list-table-columns";

type ClaimOrderTableProps = {
  records: ClaimOrderListItem[];
  page: number;
  selectedRecords?: ClaimOrderListItem[];
  onSelectedRecordsChange?: (records: ClaimOrderListItem[]) => void;
};

export const ClaimOrderTable: React.FC<ClaimOrderTableProps> = ({
  records,
  page,
  selectedRecords,
  onSelectedRecordsChange
}) => {
  const { columns } = useClaimOrderListTableColumns(page);

  return (
    <DataTable
      minHeight={10}
      columns={columns}
      records={records}
      selectedRecords={selectedRecords}
      onSelectedRecordsChange={onSelectedRecordsChange}
      idAccessor="order_id"
    />
  );
};
